import { get } from 'lodash/fp';

import * as fromReducer from './reducer';

const getSpatialFromReducer = get('spatial.activityLogs');

export const getIsLoading = state => fromReducer.getIsLoading(getSpatialFromReducer(state));

export const getActivityLogs = state => fromReducer.getActivityLogs(getSpatialFromReducer(state));
